export const QUERY_EXACT_TERMS = 10
export const MAX_TERMS = 3
export const SENTENCES_FOR_EACH_TERM = 5
